import { store } from "@/store/LoginDataStore";
import { useCookie } from "vue-cookie-next";

export const useCookieStore = () => {
  const cookie = useCookie();

  const readCookiesToStore = () => {
    if (cookie.isCookieAvailable("customerId")) {
      store.setCustomerId(cookie.getCookie("customerId"));
    }
    if (cookie.isCookieAvailable("username")) {
      store.setUsername(cookie.getCookie("username"));
    }
    if (cookie.isCookieAvailable("password")) {
      store.setPassword(cookie.getCookie("password"));
    }
  };

  const createCookiesFromStore = (
    username: string,
    customerId: string,
    password: string
  ) => {
    if (username) {
      cookie.setCookie("username", username, {
        expire: "5min",
      });
    }
    if (customerId) {
      cookie.setCookie("customerId", customerId, {
        expire: "5min",
      });
    }
    if (password) {
      cookie.setCookie("password", password, {
        expire: "5min",
      });
    }
  };

  return {
    readCookiesToStore,
    createCookiesFromStore,
  };
};
